import React from "react";
import { useParams } from "react-router-dom";
import TitleHelmet from "@/components/TitleHelmet";
import LocationZonesList from "@/features/accounts/components/LocationZonesList";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import styles from './location-zones.module.scss';

const LocationZones: React.FC = () => {
  const { companyNumber, locationId } = useParams<{ companyNumber: string; locationId: string }>();

  return (
    <React.Fragment>
      <TitleHelmet title="Location Zones" />
      <LocationZonesList 
        companyNumber={companyNumber || ""} 
        locationId={locationId || ""} 
      />
    </React.Fragment>
  );
};

export default withAuthenticationRequired(LocationZones); 